import React from 'react';
import { components, OptionProps } from 'react-select';

import { DestinationOption } from '@lt/api/dist/methods/references/types';
import { BodyOption } from './components/BodyOption';

export const Option = (props: OptionProps<DestinationOption, false>) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <BodyOption {...data} />
    </components.Option>
  );
};
